import axios from 'axios';

// const url = `http://localhost:4000`
const url = process.env.REACT_APP_BACKEND_URL || `https://api.careerroshi.com`

export const FetchCoachList = async (status) =>{
    const coaches = await axios.get(`${url}/user/fetchCoatches`, {params: {
        status
    }});
    return coaches;
}

export const UpdateCoachStatus = async (id, status) => {
    const coaches = await axios.post(`${url}/user/updateCoachStatus`, {
        id,
        status
    });

    return coaches;
}